import { Directive, ElementRef, OnInit, inject } from '@angular/core';

/** Place the host on document.body so position:fixed uses the screen, not a transformed parent. */
@Directive({
  selector: '[appBodyPortal]',
  standalone: true
})
export class BodyPortalDirective implements OnInit {
  private readonly host = inject(ElementRef<HTMLElement>);

  ngOnInit(): void {
    this.host.nativeElement.ownerDocument.body.appendChild(this.host.nativeElement);
  }
}
